import React from "react";
import { Modal, Button } from "@mantine/core";
import "./SubscriptionDetailsModal.css";
import { Order, UserSubscription } from "@/api/types";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Receipt from "../../Shared/Receipt/Receipt";

interface SubscriptionDetailsModalProps {
  opened: boolean;
  onClose: () => void;
  subscriptionDetails: UserSubscription;
  subscriptionOrder: Order;
}

const SubscriptionDetailsModal: React.FC<SubscriptionDetailsModalProps> = ({
  opened,
  onClose,
  subscriptionDetails,
  subscriptionOrder,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Godišnja pretplata"
      centered
      size="xl"
      transitionProps={{ transition: "fade-up" }}
      classNames={{
        inner: "subscription-details-inner",
        content: "subscription-details-content",
        body: "subscription-details-body",
        header: "subscription-details-header",
        title: "subscription-details-title",
      }}
    >
      <div className="flex flex-col justify-between h-full subscription-details-root">
        <div className="flex flex-col gap-[1rem]">
          <div className="text-[#0b1a29] text-base font-bold">
            {subscriptionDetails.subscription.title ?? "Godišnja pretplata"}
          </div>
          <div className="self-stretch text-[#0b1a29] text-sm font-medium">
            Kupnjom pretplate ostvarujete pravo na čitanje svakog broja revije
            izdanog za vrijeme trajanja pretplate.
          </div>
        </div>

        <PDFDownloadLink
          document={<Receipt order={subscriptionOrder} />}
          fileName={`${subscriptionOrder.guid}.pdf`}
          className="subscription-details-modal-button-container"
        >
          {({ loading }) => (
            <Button
              variant="filled"
              color="#004a99"
              radius="xl"
              size="md"
              className="order-details-modal-button"
            >
              {loading ? "Učitavanje..." : "Preuzmi račun"}
            </Button>
          )}
        </PDFDownloadLink>
      </div>
    </Modal>
  );
};

export default SubscriptionDetailsModal;
